<template>
    <div class="spxqy1">
        <div v-if="plusList.length>0">
            <div>
                <van-swipe :autoplay="3000" height="350" width="100%" indicator-color="white">
                    <van-swipe-item v-for="item in imgList">
                        <van-image :src="item.imgUrl"/>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <van-tabs v-model="active" @click="setPlus">
                <van-tab :title="item.psgName" v-for="item in plusList">
                    <van-cell-group custom-class="goods-cell-group" style="margin-top: 10px">
                        <van-cell custom-class="goods-express" style="padding: 3px 17px;">
                            <van-col span="10">
                                <span style="height: 20px;color: #ff4d51;font-size: 18px">¥{{item.sellingPrice}}</span>
                                <span class="jg-span">原价：{{item.originalPrice}}</span>
                            </van-col>
                        </van-cell>
                    </van-cell-group>
                    <van-cell-group custom-class="goods-cell-group">
                        <van-cell icon="shop-o" is-link @click="">
                            <span style="font-size: 12px">查看可用门店</span>
                        </van-cell>
                    </van-cell-group>
                    <van-cell-group custom-class="goods-cell-group">
                        <van-coupon-cell
                                icon="coupon-o"
                                :coupons="coupons"
                                :chosen-coupon="chosenCoupon"
                                @click="showList = true"
                                style="font-size: 12px"
                        />
                    </van-cell-group>
                    <van-cell-group custom-class="goods-cell-group">
                        <van-cell :border="false">
                        </van-cell>
                        <van-cell style="padding: 0px 17px 11px 17px">
                            <div style="display: flex;flex-direction: column;">
                                <span style="font-size: 12px">运费 请以提交订单时为准</span>
                                <div style="font-size: 10px;display:flex;flex-direction: row">
                                    <span style="margin-right: 10px">Θ店铺发货与售后</span>
                                    <span style="margin-right: 10px">Θ可配送全球</span>
                                    <span>Θ商品不支持退款</span>
                                </div>
                            </div>
                        </van-cell>
                    </van-cell-group>
                    <van-tabs v-model="active1">
                        <div style="padding-bottom: 5px">
                            <van-tab>
                                <template #title>
                                    <div class="tab-titel">内容介绍</div>
                                </template>
                                <div style="width: 95%;margin:auto;">
                                    <span style="font-size: 13px;color: #dddddd;display:block;text-align: center;margin-bottom: 8px;margin-top: 8px">- 使用说明( {{item.kxTitle}} ) -</span>
                                    <div style="display: flex;flex-direction: column;font-size: 13px;border: #dddddd solid 1px;margin-bottom: 12px"
                                         v-for="it in item.goodsItemList">
                                        <div style="height: 25px;line-height: 25px;background-color: #FAF1E9;display: flex;flex-direction: row;font-size: 12px">
                                            <span style="width: 47%;padding: 0px 8px">{{it.itemName}}</span>
                                            <span style="width: 26%;padding: 0px 8px;text-align: right">{{it.quantity+'份/RMB'}}</span>
                                            <span style="width: 26%;padding: 0px 8px;text-align: center">{{it.quantity*it.price}}</span>
                                        </div>
                                        <div style="padding: 15px">
                                            <p style="height: 25px">说明:</p>
                                            <span style="
                         height: 20px;line-height: 20px">
                            {{it.note}}
                        </span>
                                        </div>
                                    </div>
                                </div>
                            </van-tab>
                            <van-tab>
                                <template #title>
                                    <div class="tab-titel">图文详情</div>
                                </template>
                                <div>
                                    <p v-html="item.description"></p>
                                </div>
                            </van-tab>
                            <van-tab>
                                <template #title>
                                    <div class="tab-titel">购买须知</div>
                                </template>
                                <div style="padding: 8px">
                                    <span style="font-size: 13px;display: block;text-align: center">暂无</span>
                                </div>
                            </van-tab>
                        </div>
                        <div class="kb-btn">
                        </div>
                    </van-tabs>
                </van-tab>
            </van-tabs>
        </div>
        <van-popup v-model="show" position="bottom" closeable lock-scroll overlay round
                   style="height: 66%;">
            <div class="specs">
                <div class="sku-info">
                    <img :src="plus.imgUrl"/>
                    <div style="display: flex;flex-direction: column;justify-content: center;padding-left: 12px">
                        <span style="font-size: 13px">{{plus.psgName}}</span>
                        <span style="color: #ff4d51;font-size: 12px;margin-top:8px">¥{{plus.sellingPrice}} <span
                                class="jg-span">{{plus.originalPrice}}</span></span>
                    </div>
                </div>
                <div class="sku-spec">
                    <span style="font-size: 13px;color: #dddddd;display:block;text-align: center;margin-bottom: 3px;">- 使用说明( {{plus.kxTitle}} ) -</span>
                    <div class="spm-item">
                <span v-for="(goods,index) in plus.goodsItemList" class="spm-item-spec"
                      :class="{'spec-active':index==goodsActive}"
                      @click="checkedGoods(index,goods)">
                 {{goods.itemName}}
                </span>
                    </div>
                    <div style="margin-bottom: 55px;margin-top: 30px">
                        <span>规格/尺码</span>
                        <van-cell-group custom-class="goods-cell-group">
                            <van-cell :border="false">
                                <div style="display: flex;flex-direction: row;justify-content:space-between;margin: 5px 0px"
                                     v-for="item in specList">
                                    <span style="font-size: 12px">{{item.itemName}}</span>
                                    <van-stepper min="0" v-model="item.total" :max="item.quantity"
                                                 @plus="addNum(item,item.total)"
                                                 @minus="delNum" @change/>
                                </div>
                            </van-cell>
                        </van-cell-group>
                    </div>
                </div>
            </div>
            <div class="d-btn">
                <van-button size="large" class="spec-btn" @click="setSku" style="background-color: #F04569">立即购买
                </van-button>
            </div>
        </van-popup>
        <div class="gm-btn" v-if="plusList.length>0">
            <span class="jg-btn">¥ {{plus.sellingPrice}}</span>
            <span class="kt-btn" @click="toSpec">立即开通</span>
        </div>
    </div>
</template>

<script>
    import {getCookie, getDeptId} from "../../../utils/auth";

    export default {
        data() {
            return {
                token: '',
                active: 0,
                active1: 0,
                plusList: [],
                plus: {},
                imgList: [],

                show: false,
                goods: {},

                specList: [],

                chosenCoupon: -1,
                coupons: [],
                showList: false,


                skuNum: 0,

                goodsActive: 0,
                specActive: 0,
                // adsId: '',
                addressInfo: {},

            };
        },
        async created() {
            this.spuId = this.$route.params.spuId
            this.token = getCookie('spmToken')
            this.deptId = getDeptId()
            this.getPlusList()
        },
        methods: {
            async getPlusList() {
                let data = {
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getSpmPlusList", data)
                this.plusList = res.list
                if (res.list.length > 0) {
                    this.imgList = res.list[this.active].spuImgList
                    this.plus = this.plusList[this.active]
                }
            },
            setPlus(active) {
                this.imgList = this.plusList[active].spuImgList
                this.plus = this.plusList[active]
            },
            onClickIcon() {
            },
            onClickLeft() {
                this.$router.go(-1)
            },
            async toSpec() {
                if (!this.token) {
                    this.$router.push('/empower/' + this.deptId)
                    return;
                }
                let data = {
                    lvId: this.plus.id,
                    token: this.token
                }
                let res = await this.$post("/spm/getIsBuy", data)
                if (res.code == 200) {
                    this.show = true
                    if (this.plus.goodsItemList.length > 0) {
                        this.goodsActive = 0
                        this.goods = this.plus.goodsItemList[0]
                        if (this.goods.memberItems.length > 0) {
                            this.specList = this.goods.memberItems
                        }
                    }
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }

            },

            checkedGoods(index, goods) {
                this.goodsActive = index
                this.goods = goods
                if (goods.memberItems.length > 0) {
                    this.specList = goods.memberItems
                }
            },
            addNum(item, total) {
                this.skuNum = this.skuNum + 1
                if (parseInt(this.skuNum) > this.plus.quantity) {
                    item.total = total
                    this.$toast('超出所能选的商品数量！');
                    return;
                }
            },
            delNum() {
                this.skuNum = parseInt(this.skuNum - 1)
            },
            setSku() {
                if (parseInt(this.skuNum) > this.plus.quantity) {
                    this.$toast('所选的商品数量超出' + this.plus.quantity + ',不能下单！');
                    return;
                }
                if (parseInt(this.skuNum) < this.plus.quantity) {
                    this.$toast('所选的商品数量低于' + this.plus.quantity + ',不能下单！');
                    return;
                }
                var arr = []
                this.plus.goodsItemList.forEach(item => {
                    item.memberItems.forEach(mb => {
                        if (mb.total > 0) {
                            arr.push(mb)
                        }
                    })
                })
                this.toPlusBuy(arr)
            },

            async toPlusBuy(arr) {
                let data = {
                    goodsId: this.plus.id,
                    goodsStr: JSON.stringify(arr),
                    type: 'plus',
                    token: this.token
                }
                let res = await this.$post("/spm/toRedisBuy", data)
                if (res.code == 200) {
                    this.show = true
                    this.toBuy(res.no, this.plus.skuId)
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
            toBuy(no, goodsId) {
                this.$router.push('/buyGoods/' + this.deptId + '/' + no + '/plus/' + goodsId)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .spxqy1 {
        height: 100%;
        /*padding-bottom: 100px;*/
    }

    .goods-img {
        width: 100%;
        display: block;
    }

    .goods-message .van-cell__title {
        font-size: 16px;
    }

    .goods-message .van-cell__label {
        color: #f44;
    }

    .goods-express {
        color: #999;
        font-size: 12px;
    }

    .goods-express .van-cell {
        color: #999;
        font-size: 12px;
        padding: 5px 15px;
    }

    .goods-express .van-col {
        text-align: left;
    }

    .goods-cell-group {
        margin: 0 0;
    }

    .goods-cell-group .van-cell__value {
        color: #999;
    }

    .goods-tag {
        margin-left: 5px;
    }

    .goods-action {
        position: relative !important;
    }

    .jg-span {
        height: 20px;
        margin-left: 8px;
        font-size: 10px;
        text-decoration: line-through;
        color: #888888
    }

    .tab-titel {
        font-size: 12px;
    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }

    .specs {
        width: 95%;
        margin: auto;
        padding-top: 12px;
        height: 100%;
        overflow: hidden;
    }

    .sku-info {
        border-bottom: #BBBBBB solid 1px;
        padding-bottom: 5px;
        display: flex;
        flex-direction: row;
    }

    .sku-info img {
        width: 50px;
        height: 50px;
    }

    .sku-spec {
        display: flex;
        flex-direction: column;
        font-size: 13px;
        padding: 10px 5px;
        height: 100%;
        overflow: auto;
        padding-bottom: 65px;
        margin-top: 10px;
        overflow: auto;
    }

    .spm-item {
        display: flex;
        flex-flow: row wrap;
        margin-top: 12px;
    }

    .spm-item-spec {
        box-sizing: border-box;
        height: 32px;
        margin: 4px;
        padding: 2px 26px;
        font-size: 12px;
        /*margin-bottom: 8px;*/
        display: flex;
        flex-direction: column;
        cursor: pointer;
        border: #dddddd solid 1px;
        width: calc((100% - 15px) / 2); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((100% - 20px) / 2);
        max-width: calc((100% - 20px) / 2);
        justify-content: center;
        align-items: center;
        /*&:nth-child(4n + 4) {*/
        /*  margin-right: 0;*/
        /*}*/
    }

    .spec-active {
        color: #F0431D;
        border: #F0431D solid 1px;
    }

    .spec-btn {
        font-size: 15px;
        width: 100%;
        color: #FFFFFF;
        height: 38px;
        line-height: 38px;
    }

    .spec-btn1 {
        font-size: 15px;
        width: 100%;
        color: #FFFFFF;
        height: 38px;
        line-height: 38px;
    }

    .d-btn {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 0px;
        background-color: #FFFFFF;
        height: 38px;
    }

    .kb-btn {
        position: relative;
        height: 80px;
        transform: translate(-50%);
        left: 50%;
        display: flex;
        flex-direction: row;
        justify-content: center
    }

    .gm-btn {
        position: fixed;
        transform: translate(-50%);
        left: 50%;
        height: 40px;
        bottom: 50px;
        display: flex;
        flex-direction: row;
        justify-content: center
    }

    .jg-btn {
        height: 38px;
        line-height: 38px;
        font-size: 15px;
        width: 150px;
        background-color: #DBBB88;
        text-align: center;
        border-top-left-radius: 18px;
        border-bottom-left-radius: 18px;
        color: #FFFFFF;
        background: linear-gradient(-68deg, transparent 15px, #DBBB88 0) right;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-right: -10px;
    }

    .kt-btn {
        height: 38px;
        line-height: 38px;
        font-size: 15px;
        width: 150px;
        background-color: #3F4141;
        text-align: center;
        border-top-right-radius: 18px;
        border-bottom-right-radius: 18px;
        color: #C5A87A;
        background: linear-gradient(110deg, transparent 15px, #3F4141 0) left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-left: -10px;
    }


</style>
